import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { Button, Flex, Typography } from 'antd';

import {
    getFields,
    getInitialValues,
    validationSchema,
    validationSchemaKeys,
} from '../fields';
import { renderField } from '../../../../promocodes/utils/fields';
import {
    useCreateUnitPayKeysMutation,
    useLazyReadUnitPayKeysQuery,
} from '../../../service/paymentSettings.api';
import { FORM_WIDTH, formikCommonOptions } from '../../../utils/options';
import { UnitpayKeysValues } from '../../../service/paymentSettings.interface';
import { useApiErrorNotification } from '../../../../../../../hooks/useApiErrorNotification';
import { useApiSuccessNotification } from '../../../../../../../hooks/useApiSuccessNotification';
import { StepTitle } from '../../steps/StepTitle';
import { StepList } from '../../steps/StepList';
import { Copy } from '../../../../../../../shared/ui/Copy';

const { Text } = Typography;

export const UnitpatStepAccess = () => {
    const { id } = useParams();

    const [createPaymentKeys, { isSuccess, isError, error, data }] =
        useCreateUnitPayKeysMutation();

    const [getPaymentKeys, { data: keys }] = useLazyReadUnitPayKeysQuery();

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(isSuccess, data);

    const onSubmit = async (values: UnitpayKeysValues) => {
        const data = {
            shop_id: +id,
            ...values,
        };

        await createPaymentKeys(data);
    };

    useEffect(() => {
        if (id) {
            getPaymentKeys({ shop_id: +id }, true);
        }
    }, [id]);

    const formik = useFormik({
        initialValues: { ...keys } || getInitialValues('keys'),
        validationSchema: validationSchemaKeys,
        onSubmit: onSubmit,
        ...formikCommonOptions,
    });

    const currentField = getFields('keys');

    return (
        <Flex vertical gap={8}>
            <StepTitle text={'Шаг 3. Предоставление доступа'} />

            <StepList>
                <Text>
                    1. в настройках проекта в сервисе Unitpay добавьте в поле
                    "Обработчик платежей" ссылку:
                    <Copy text={'https://api.spodial.com/unitpay/notify'} />
                </Text>
                <Text>
                    2. скопируйте из настроек роекта в сервисе Unitpay значения
                    "ID проекта" и "Секретный ключ", "Публинчый ключ" и вставьте
                    в поля ниже:
                </Text>
            </StepList>

            <Flex vertical style={{ width: FORM_WIDTH }} gap={8}>
                {currentField.map(field => (
                    <React.Fragment key={field.name}>
                        {renderField(field, formik)}
                    </React.Fragment>
                ))}

                <Flex vertical={false} justify={'space-between'}>
                    <Button
                        disabled={!formik.isValid || !formik.dirty}
                        onClick={() => onSubmit(formik.values)}
                    >
                        Сохранить
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};
